<template>
  <div class="cx-categories">
    <CxCategory v-for="(category, index) in cxTab.categories"
                :afsData="afsData"
                :category="category"
                :dashboardData="dashboardData"
                :explorationData="explorationData"
                :key="index"
                :nonAfsData="nonAfsData"
                :threshold="threshold"
                :dealerData="dealerData"
                :clientInfo="clientInfo">
    </CxCategory>
  </div>
</template>

<script>
import CxCategory from './CxCategory.vue';

export default {
  components: {
    CxCategory
  },

  props: {
    afsData:            { type: Object, default: () => undefined },
    cxTab:              { type: Object, required: true },
    dashboardData:      { type: Object, required: true },
    explorationData:    { type: Array, required: true },
    nonAfsData:         { type: Object, default: () => undefined },
    threshold:          { type: Array, required: true },
    scoreId:            { type: Number, default: () => undefined },
    dealerData:         { type: Object, default: () => undefined},
    clientInfo:         { type: Object, default: () => undefined},
  }
}
</script>
